// Wrapper for react-native as self is not defined in RN enviroment

let globalObject;
try {
  globalObject = self;
} catch (e) {
  try {
    globalObject = global;
  } catch (error) {
    globalObject = {};
  }
}

export default globalObject;
